import React, { Component } from 'react'
import { withStyles } from 'material-ui/styles'
import { inject, observer } from 'mobx-react'
import { Link, withRouter } from 'react-router-dom'
import HeaderAlchemy from '@/components/HeaderAlchemy'
import { GC_USER_ID } from '@/constants'
import 'react-table/react-table.css'

import {
  Paper,
  Tabs,
  Tab,
  Typography,
  Button,
  CircularProgress
} from 'material-ui'
import { ALABASTER } from '@/constants'
import ReadingTrack from '@/routes/alchemy/reading'
import ProjectsTrack from '@/routes/alchemy/projects'
import BodyWeightTrack from '@/routes/alchemy/bodyweight'
import ExpenseTrack from '@/routes/alchemy/expense'
import SleepTrack from '@/routes/alchemy/sleep'
import TodayTrack from '@/routes/alchemy/today'
import Timeline from '@/routes/alchemy/timeline'
import ComingSoon from '@/routes/alchemy/comingsoon'
import LiveHelpIcon from 'material-ui-icons/LiveHelp'

import { READ_DATASETNAME } from '@/graphql/queries/dataset'
import { UPDATE_DATASET } from '@/graphql/mutations/dataset'

import { graphql, withApollo } from 'react-apollo'
import { adminTrackers } from '@/graphql/queries/tracker'

import { ENERGY_TRACKER_ID } from '@/constants'

function TabContainer(props) {
  return <Typography component="div">{props.children}</Typography>
}

const styles = theme => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper
  },
  toolbar: {
    backgroundColor: ALABASTER,
    color: 'white',
    cursor: 'pointer'
  },
  toolbarTab: {},
  toolbarTabAdd: {
    top: 15
  },
  appBar: {
    top: 'auto',
    bottom: 0
  },
  toolbarBottom: {
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  fabButton: {
    position: 'absolute',
    zIndex: 1,
    top: -15,
    left: 0,
    right: 0,
    margin: '0 auto'
  },
  paper: {
    position: 'absolute',
    width: theme.spacing.unit * 50,
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    boxShadow: theme.shadows[5],
    padding: theme.spacing.unit * 4
  },
  innerWrapTimer: {
    position: 'relative',
    top: -180
  },
  centerBlock: {
    alignItems: 'center',
    width: '100%',
    height: '100%'
  },
  startPageEmpty: {
    textAlign: 'center',
    display: 'grid',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    backgroundColor: 'white',
    width: '100%',
    height: 200
  },
  startPageEmptyGrey: {
    textAlign: 'center',
    display: 'grid',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    backgroundColor: ALABASTER,
    width: '100%',
    height: 200
  },
  comingsoon: {
    fontSize: 12,
    color: 'grey',
    opacity: 0.8,
    backgroundColor: 'white',
    width: '60%',
    padding: window.innerWidth * 0.2,
    textAlign: 'center',
    left: 0
  },
  editIcons: {
    color: 'rgba(0, 0, 0, .1)',
    width: 160,
    height: 160
  },
  icon: {
    backgroundColor: 'rgba(255, 255, 255, .6)',
    boxShadow: '0px 5px 30px #dddddd'
  },
  paperBlock: {
    position: 'relative',
    margin: theme.spacing.unit * 1,
    height: 60,
    width: 60,
    cursor: 'pointer',
    borderRadius: 30
  },
  tabText: {
    textAlign: 'center',
    fontSize: 12,
    color: 'grey',
    lineHeight: 1.1,
    width: 60,
    textTransform: 'capitalize',
    whiteSpace: 'initial',
    overflow: 'hidden'
  },
  bookBlockChecked: {
    textAlign: 'center',
    boxShadow: '0px 0px 10px #eeeeee',
    backgroundImage:
      'linear-gradient(to bottom, rgba(80, 227, 194, .8) 0%, #ffffff 80%)',
    width: 60,
    height: 60,
    position: 'absolute',
    top: 0,
    left: 0,
    borderRadius: 30
  },
  bookBlockCheckedCurrent: {
    textAlign: 'center',
    boxShadow: '1px 1px 10px #aaaaaa',
    backgroundImage:
      'linear-gradient(to bottom, rgba(80, 227, 194, .8) 0%, #ccffff 80%)',
    width: 60,
    height: 60,
    position: 'absolute',
    top: 0,
    left: 0,
    borderColor: 'red',
    borderRadius: 30
  },
  iconBook: {
    color: 'rgba(0, 0, 0, .1)',
    width: 30,
    height: 30
  },
  loadingProgress: {
    margin: theme.spacing.unit * 2,
    color: 'lightgrey'
  }
})

@withApollo
@inject('resultTrackerPref')
@observer
@graphql(READ_DATASETNAME, {
  name: 'readUserTrackerPreference',
  options: ({ match }) => ({
    variables: {
      dataName: 'defaultUserTrackerPreference',
      userId: global.localStorage.getItem(GC_USER_ID)
        ? global.localStorage.getItem(GC_USER_ID)
        : 'NA'
    }
  })
})
@graphql(UPDATE_DATASET, { name: 'UpdateDataSet' })
@withRouter
@graphql(adminTrackers, {
  options: {
    variables: {
      isPublic: true,
      isAdmin: true
    }
  }
})
@withStyles(styles)
export default class AlchemySingle extends Component {
  constructor(props) {
    super(props)
    this.state = {
      open: false,
      toolbarSelected: 'timeline',

      session: 30,
      break: 5,
      timer: 30 * 60,
      isSessionNow: true,
      isPaused: false,
      eAngle: 0,
      isUpdated: false,
      time: 0
    }
    this.handleTabChange = this.handleTabChange.bind(this)
  }

  handleTabChange = (event, value) => {
    this.props.resultTrackerPref.tabSelected = parseInt(value, 10)
    this.setState({
      toolbarSelected: value === 'timeline' ? 'timeline' : parseInt(value, 10)
    })
  }

  handleOpen = () => {
    this.setState({ open: true })
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  componentWillMount() {
    window.scrollTo(0, 0)
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (!userId) {
      this.props.history.push(`/start`)
    }
  }

  render() {
    const { classes } = this.props
    if (this.props.data.loading) {
      return (
        <div>
          <CircularProgress className={classes.loadingProgress} size={40} />
        </div>
      )
    }
    const userId = global.localStorage.getItem(GC_USER_ID)
    if (this.props.data.allTrackers && this.props.data.allTrackers.length > 0) {
      this.props.data.allTrackers.forEach(t => {
        switch (t.name) {
          case 'Energy':
            global.localStorage.setItem(ENERGY_TRACKER_ID, t.id)
            break
          default:
            break
        }
      })
    }

    var allTrackerPref = []
    if (
      this.props.readUserTrackerPreference &&
      this.props.readUserTrackerPreference.loading
    ) {
      return (
        <div>
          <CircularProgress className={classes.loadingProgress} size={40} />
        </div>
      )
    }

    if (
      this.props.readUserTrackerPreference &&
      this.props.readUserTrackerPreference.error
    ) {
      if (!userId) {
        this.props.history.push(`/login`)
      }
      return (
        <div>
          Error: readUserTrackerPreference:{' '}
          {this.props.readUserTrackerPreference.error}
        </div>
      )
    }

    if (this.props.resultTrackerPref.trackers.length === 0) {
      if (this.props.readUserTrackerPreference.allDataSets.length === 1) {
        if (
          this.props.readUserTrackerPreference.allDataSets[0].dataPoints !== ''
        ) {
          allTrackerPref = JSON.parse(
            this.props.readUserTrackerPreference.allDataSets[0].dataPoints
          )
          this.props.resultTrackerPref.updateTrackers(allTrackerPref)
          this.props.resultTrackerPref.updateTrackersActiveFromAll()
        }
      } else if (
        this.props.readUserTrackerPreference.allDataSets.length === 0
      ) {
        console.log('no trackers yet, please add tracker')
      } else {
        return (
          <div>
            Error, please contact our support team [readUserTrackerPreference:{' '}
            {this.props.readUserTrackerPreference.allDataSets.length}]
          </div>
        )
      }
    }

    if (this.props.resultTrackerPref.tabSelected === 'add') {
      if (this.props.resultTrackerPref.trackersActive.length === 0) {
        this.props.resultTrackerPref.tabSelected = 'add'
      } else {
        this.props.resultTrackerPref.tabSelected = this.props.resultTrackerPref.trackersActive[0].id
        this.props.resultTrackerPref.tracker = this.props.resultTrackerPref.trackersActive[0]
      }
    } else {
      if (!this.props.resultTrackerPref.tabSelected) {
        if (this.props.resultTrackerPref.trackersActive.length > 0) {
          this.props.resultTrackerPref.tabSelected = this.props.resultTrackerPref.trackersActive[0].id
          this.props.resultTrackerPref.tracker = this.props.resultTrackerPref.trackersActive[0]
        }
      } else {
        if (this.props.resultTrackerPref.trackersActive.length === 0) {
          this.props.resultTrackerPref.tabSelected = 'add'
        }
      }
    }

    return (
      <div>
        <HeaderAlchemy />
        <Tabs
          value={this.state.toolbarSelected}
          onChange={this.handleTabChange}
          className={classes.toolbar}
          centered
          scrollable
          indicatorColor="primary"
          textColor="primary"
        >
          <Tab
            key={`key-timeline`}
            value={'timeline'}
            className={classes.toolbarTab}
            icon={
              <Paper className={classes.paperBlock}>
                <div
                  key={`bookblock-key-timeline`}
                  className={
                    this.state.toolbarSelected === 'timeline'
                      ? classes.bookBlockCheckedCurrent
                      : classes.bookBlockChecked
                  }
                >
                  <img
                    alt=""
                    className={classes.iconBook}
                    src={process.env.PUBLIC_URL + '/cloud_done.png'}
                  />
                  <Typography
                    variant="body1"
                    id="bookName"
                    className={classes.tabText}
                  >
                    Timeline
                  </Typography>
                </div>
              </Paper>
            }
            label={''}
          />
          {this.props.resultTrackerPref.trackersActive.map(tile => (
            <Tab
              key={`key-${tile.id}`}
              value={tile.id}
              className={classes.toolbarTab}
              icon={
                <Paper className={classes.paperBlock}>
                  <div
                    key={`bookblock-key-${tile.id}`}
                    className={
                      tile.id === this.state.toolbarSelected
                        ? classes.bookBlockCheckedCurrent
                        : classes.bookBlockChecked
                    }
                  >
                    <img
                      alt=""
                      className={classes.iconBook}
                      src={process.env.PUBLIC_URL + tile.img}
                    />
                    <Typography
                      variant="body1"
                      id="bookName"
                      className={classes.tabText}
                    >
                      {tile.name}
                    </Typography>
                  </div>
                </Paper>
              }
              label={''}
            />
          ))}
          <Tab
            key={'tab-add'}
            value={'add'}
            className={classes.toolbarTabAdd}
            icon={
              <img alt="" src={process.env.PUBLIC_URL + '/addNew_72.png'} />
            }
            label={'Add'}
            component={Link}
            to="../preference"
          />
        </Tabs>
        {this.state.toolbarSelected === 2 && (
          <TabContainer>
            <ReadingTrack />
          </TabContainer>
        )}
        {this.state.toolbarSelected === 1 && (
          <TabContainer>
            <BodyWeightTrack />
          </TabContainer>
        )}
        {this.state.toolbarSelected === 4 && (
          <TabContainer>
            <ExpenseTrack />
          </TabContainer>
        )}
        {this.state.toolbarSelected === 5 && (
          <TabContainer>
            <SleepTrack />
          </TabContainer>
        )}
        {this.state.toolbarSelected === 6 && (
          <TabContainer>
            <TodayTrack />
          </TabContainer>
        )}
        {this.state.toolbarSelected === 'timeline' && (
          <TabContainer>
            <Timeline />
          </TabContainer>
        )}
        {this.state.toolbarSelected === 7 && (
          <TabContainer>
            <ProjectsTrack />
          </TabContainer>
        )}
        {this.state.toolbarSelected === 3 && (
          <TabContainer>
            <ComingSoon
              track={this.props.resultTrackerPref.tracker.name}
              img="https://i.gifer.com/6ekW.gif"
            />
          </TabContainer>
        )}
        {this.state.toolbarSelected >= 9 && (
          <TabContainer>
            <ComingSoon
              track={this.props.resultTrackerPref.tracker.name}
              img="https://i.gifer.com/6ekW.gif"
            />
          </TabContainer>
        )}
        {this.state.toolbarSelected === 'Track Carbon Saved' && (
          <TabContainer>
            <ComingSoon
              track="Track Carbon Saved"
              img="https://i.gifer.com/Q5aj.gif"
            />
          </TabContainer>
        )}
        {this.state.toolbarSelected === 'add' &&
          this.props.resultTrackerPref.trackersActive.length === 0 && (
            <TabContainer>
              <div id="blank" className={classes.comingsoon}>
                <img
                  alt=""
                  style={{ width: window.innerWidth * 0.6 }}
                  src={this.props.img}
                />
                <div
                  style={{
                    width: window.innerWidth * 0.6,
                    position: 'relative',
                    textAlign: 'center'
                  }}
                >
                  <LiveHelpIcon className={classes.editIcons} />
                </div>
                <Typography variant="display1">
                  <br /> You don't have any tracking yet. <br />
                  <br />
                </Typography>

                <div
                  style={{ width: '100%', paddingTop: 36, paddingBottom: 22 }}
                >
                  <Button
                    className={classes.icon}
                    size="large"
                    component={Link}
                    to="/preference"
                  >
                    <Typography
                      variant="title"
                      style={{ fontSize: 20, color: '#20c5a2' }}
                    >
                      Start Tracking
                    </Typography>
                  </Button>
                </div>
              </div>
            </TabContainer>
          )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/routes/alchemy/single.js